import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import * as yup from "yup";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../services/store/store";
import {handleUserCreated} from "../../../services/store/reducers/session/slice";
import {UserService} from "../../../services/api/UserService";
import ErrorText from "../../../components/ErrorText";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";

interface Props {

}

const RegisterCreateProfile = ({}: Props) => {

    const { createUser } = UserService();

    const dispatch = useDispatch<AppDispatch>();

    const [errMsg, setErrMsg] = useState<string>();
    const [profileCreating, setProfileCreating] = useState(false);

    const schema = yup.object().shape({
        firstName: yup.string().required("First name is required"),
        lastName: yup.string().required("Last name is required"),
    });

    useEffect(() => setProfileCreating(false), []);

    const submitForm = async (values: any) => {
        if (profileCreating) {
            return;
        }

        setProfileCreating(true);
        setErrMsg(undefined);

        const resp = await createUser(values.firstName, values.lastName);

        if (resp.error) {
            setErrMsg(resp.error.message);
            setProfileCreating(false);
            return;
        }

        if (!resp.user) {
            setProfileCreating(false);
            return;
        }

        setProfileCreating(false);
        dispatch(handleUserCreated(resp.user));
    };

    return (
        <FormContainer>
                <div className={"header_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <span className={"heading"} style={{ alignSelf: 'flex-start' }}>Create Profile</span>

                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        firstName: "",
                        lastName: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <form onSubmit={handleSubmit}>
                            <h3 className={"onboarding_label"}>First Name</h3>
                            <input
                                className="onboarding_input"
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={values.firstName}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />

                            <h3 className={"onboarding_label"}>Last Name</h3>
                            <input
                                className="onboarding_input"
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={values.lastName}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />

                            {errMsg && <ErrorBox text={errMsg}/>}

                            <div style={{ marginTop: '1.5em' }}>
                                <Button text="CREATE" type="submit" disabled={profileCreating} />
                            </div>
                        </form>
                    )}
                </Formik>
        </FormContainer>
    )
}

export default RegisterCreateProfile;